module.exports = __webpack_public_path__ + "static/media/congratulation.d9c48b2d.svg";